import { httpClient } from '@/services/http/httpClient'

import type { GetTaskResponse } from '../getTask'

export type UpdatePositionTaskRequest = {
  projectId: string
  newItems: GetTaskResponse[]
}

export async function updatePositionTask({
  projectId,
  newItems,
}: UpdatePositionTaskRequest) {
  await httpClient.put(`/projects/project-tasks/${projectId}/position`, {
    tasks: newItems,
  })
}
